<template>
  <div class="instructions">
    <h3>KAKO SE LOTITI TEGA?</h3>
    <ul>
      <li>
        <span class="number">1</span>
        <p>Obiščite spletno mesto https://tv2go.t-2.net/start in se prijavite z uporabniškim imenom in geslom, ki jih imate zapisane na ekranu. Podatke za prijavo ste prejeli tudi na vaš elektronski naslov. </p>
      </li>
      <li>
        <span class="number">2</span>
        <p>Udobno se namestite in uživajte ob ogledu! </p>
      </li>
    </ul><br><br>
  </div>
</template>

<script>
export default {
  name: "WatchLaptopInstructions"
}
</script>

<style scoped>

</style>